export default __webpack_public_path__ + "fa9f5a67b9da857ecfbf250edc4697e7.png";